import React from "react";
import PropTypes from "prop-types";
import ErrorPage from "../ErrorPage";
import { compose, setDisplayName } from "recompose";

const withApiErrorWrapper = Component => {
  const c = class extends React.Component {
    state = { error: null };

    handleError = error => {
      this.setState({ error: error });
    };

    render() {
      const error = this.state.error;
      if (error && error.status) {
        return <ErrorPage error={error} />;
      } else {
        return <Component onError={this.handleError} {...this.props} />;
      }
    }
  };

  c.propTypes = {
    onError: PropTypes.func
  };

  return c;
};

export default compose(
  setDisplayName("withApiErrorWrapper"),
  withApiErrorWrapper
);
